/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TemperatureUnit } from './TemperatureUnit';
import {
    TemperatureUnitFromJSON,
    TemperatureUnitFromJSONTyped,
    TemperatureUnitToJSON,
} from './TemperatureUnit';

/**
 * 
 * @export
 * @interface Temperature
 */
export interface Temperature {
    /**
     * 
     * @type {number}
     * @memberof Temperature
     */
    value?: number;
    /**
     * 
     * @type {TemperatureUnit}
     * @memberof Temperature
     */
    unit?: TemperatureUnit;
    /**
     * 
     * @type {string}
     * @memberof Temperature
     */
    $type?: TemperatureTypeEnum;
}


/**
 * @export
 */
export const TemperatureTypeEnum = {
    UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet: 'UnitsNet.Serialization.JsonNet.UnitsNetBaseJsonConverter`1+ValueUnit[[UnitsNet.IQuantity, Ptw.UnitsNet]], Ptw.UnitsNet.Serialization.JsonNet'
} as const;
export type TemperatureTypeEnum = typeof TemperatureTypeEnum[keyof typeof TemperatureTypeEnum];


/**
 * Check if a given object implements the Temperature interface.
 */
export function instanceOfTemperature(value?: unknown): value is Temperature {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TemperatureTypeEnum)[0];
}

export function TemperatureFromJSON(json: any): Temperature {
    return TemperatureFromJSONTyped(json, false);
}

export function TemperatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): Temperature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'unit': !exists(json, 'unit') ? undefined : TemperatureUnitFromJSON(json['unit']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TemperatureToJSON(value?: Temperature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'value': value.value,
        'unit': TemperatureUnitToJSON(value.unit),
        '$type': value.$type,
    });
}

